import type { FC, PropsWithChildren } from 'react'
import type { ButtonProps } from 'antd'

import {
  SC_Button,
} from './styled'


export type T_ButtonProps = ButtonProps & {
  customType?: 'payment'
  $isBlack?: boolean
  $extraSize?: 'veryLarge'
  $isVeryRadiused?: boolean
}

export const Button: FC<PropsWithChildren<T_ButtonProps>> = (props) => {
  const {
    children,
    ...restProps
  } = props

  return (
    <SC_Button {...restProps}>
      {children}
    </SC_Button>
  )
}
